<template>
    <div>
        <div class="xinz">
            <div class="right">
                <el-button type="warning" @click="handleTypeAdd" ><i class="fa fa-plus" /> 新增類別</el-button>
                <el-button type="warning" @click="handleAdd" ><i class="fa fa-plus" /> 新增備註</el-button>
            </div>
        </div>
        <div>
            <el-form :inline="true"  class="demo-form-inline" size="small" @submit.native.prevent @keyup.native.enter="requestRemarkList">
                <el-form-item label="">
                    <el-input placeholder="備註內容" clearable v-model="searchName">
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="searchType" placeholder="類別" clearable="">
                        <el-option
                                v-for="item in remarkList"
                                :key="item.id"
                                :label="item.typeName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="requestRemarkList" style="background-color: #4B78FF"><i class="fa fa-search" /> 搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div id="app" >
			
			 <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
			            
			              @selection-change="handleSelectionChange"
			              :data="staffs"
			              empty-text="无数据"
			              stripe
			              border
			              class="dataListTable">
			        <el-table-column
			                prop="content"
			                align="left"
			                label="備註內容">
			        </el-table-column>
                 <el-table-column
                         prop="typeName"
                         align="left"
                         label="類別">
                 </el-table-column>
			        <el-table-column
			                prop="ordering"
			                align="left"
			                label="排序">
			        </el-table-column>
			      
			        <el-table-column
			                prop="id"
			                width="100"
			                align="center"
			                label="操作">
			          <template slot-scope="scope">
			            <template>
			              <el-dropdown>
			                <el-button size="small" type="primary">
			                  <i class="fa fa-mouse-pointer"/>操作
			                </el-button>
			                <el-dropdown-menu slot="dropdown">
			                <el-dropdown-item  @click.native="handleEdit(scope.$index, scope.row)" ><i class="fa fa-edit"/> 編輯</el-dropdown-item>
			                <el-dropdown-item  @click.native="handleDelete(scope.$index, scope.row)"><i class="fa fa-trash"/> 刪除</el-dropdown-item>
			                </el-dropdown-menu>
			              </el-dropdown>
			            </template>
			          </template>
			        </el-table-column>
			      </el-table>
			
			
			
          
        </div>
        <!--分頁-->
        <div class="pagination">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>


        <!-- 新增和修改備註彈出框-->
        <el-dialog :title="dialogTypeName" :visible.sync="dialogTypeVisible" width="350px">
            <el-form :model="typeForm" size="small"  ref="typeForm" label-width="100px">
                <el-form-item label="類別名：" prop="content">
                    <el-input  v-model="typeForm.typeName"  auto-complete="off" widht="160px" placeholder="請輸入類別名"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary"  icon="el-icon-check" @click="handleTypeSave" plain>確 定</el-button>
                    <el-button @click="dialogTypeVisible = false" icon="el-icon-delete" plain>取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 新增和修改備註彈出框-->
        <el-dialog :title="dialogName" :visible.sync="dialogFormVisible" width="400px">
            <el-form :model="homeForm" size="small"  ref="homeForm" label-width="120px">
                <el-form-item label="ID"  style="display: none">
                    <el-input v-model="homeForm.id"  auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="類別：">
                    <el-select v-model="homeForm.typeId" style="width:240px"placeholder="請選擇類別">
                        <el-option
                                v-for="item in remarkList"
                                :key="item.id"
                                :label="item.typeName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="備註內容：" prop="content">
                    <el-input type="textarea" v-model="homeForm.content"  auto-complete="off" widht="160px" placeholder="請輸入內容"></el-input>
                </el-form-item>
                <el-form-item label="排序：" prop="ordering">
                    <el-input-number v-model="homeForm.ordering" controls-position="right" style="width:240px" :min="1" ></el-input-number>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  icon="el-icon-check" @click="handleSave" plain>確 定</el-button>
                    <el-button @click="dialogFormVisible = false" icon="el-icon-delete" plain>取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    import { getRemarkList,insertRemark,updateRemark,deleteRemarkById,getRemarkById,getAllTypeList } from '../api/api'

    export default {
        data() {
            var orderingValid = (rule,value,callback)=>{
                var reg=/^[1-9]\d*$/;
                if (value!=""&&value!=null){
                    if(!reg.test(value)){
                        callback(new Error(this.$t('m.m_notpitnumber')));
                    }
                }
                if (value>999999999){
                    callback(new Error(this.$t('m.m_oversize')));
                }
                callback();
            };
            return {
                sysName:'ROYAL',
                collapsed:false,
                logBg:true,
                dialogTableVisible: false,
                dialogFormVisible: false,
                dialogName:"",
                staffTableloading:false,
                staffSaveloading:false,
                searchName:'',
                searchType:'',
                staffs:[],
                dataTypeOptions:[
                    {
                        id:1,
                        value:this.$t('m.menu_salesslip')
                    },{
                        id:2,
                        value:this.$t('m.menu_returngoods')
                    }
                ],
                homeForm: {
                    id:'',
                    content:'',
                    ordering:'',
                    typeId:''
                },
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
               /* homeRules: {*/
//                    content: [
//                        {required: true, message: '內容不能為空', trigger: 'blur' },
//                        { min: 1, max: 200, message:'內容不能超過200', trigger: 'blur' }
//                    ],
//                    ordering: [
//                        {required: true, message:'排序不能為空', trigger: 'blur' },
//                        { validator: orderingValid,trigger: 'blur' }
               /*     typeId: [
                        {required: true, message:'請選擇類別', trigger: 'blur' },
                    ]
               },*/
                roles: [],
                remarkList:[],

                dialogTypeName:"",
                dialogTypeVisible: false,
                typeForm: {
                    typeName:'',
                },
            }
        },
        methods: {
            handleTypeAdd(ev){
                this.dialogTypeVisible=true;
                this.dialogTypeName='新增類別';
                this.typeForm={
                    typeName:'',
                },
                this.resetForm("typeForm");
            },
            getRemarkList(){/*查詢常用列表*/
                var params={typeName:''};
                return getAllTypeList(params).then(data =>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        this.remarkList = res.data;
                    }
                    this.searchType="";
                });
            },
            handleSelectionChange(){

            },
            requestRemarkList(){
                this.staffTableloading=true;
                var params={page:this.pager.page,size:this.pager.size,content:this.searchName.trim(),typeId:this.searchType};
                return getRemarkList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:staffs=[]}=res.data;
                        this.staffs=staffs;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.staffTableloading=false;
                    }else{
                        this.$message.error(data.errmsg);
                    }
                });
            },
            handleAdd(ev){
                this.dialogFormVisible=true;
                this.dialogName='新增';
                this.homeForm={
                    id:'',
                    content:'',
                    ordering:'',
                    typeId:''
                },
                    this.resetForm("homeForm");
            },
            handleEdit(index, row) {
                this.dialogFormVisible=true;
                this.dialogName='編輯';
                /*console.log(row.id);*/
                this.requestRemarkById(row.id);
                this.resetForm("homeForm");
            },
            handleDelete(index, row) {
                this.requestDeleteRemark(row.id);
            },
            handleCurrentChange(val){
                this.requestRemarkList();
            },
            isTypeNull(){/*是否为空*/
                if(this.typeForm.typeName ==="" || this.typeForm.typeName === null){
                    return "請輸入類別"
                }
                return "";
            },
            handleTypeSave(){
                this.$refs.typeForm.validate((valid) => {
                    let str = this.isTypeNull();
                    if(str !== ""){
                        this.dialogVisible =true;
                        this.$alert(str, '提示', {
                            confirmButtonText: '確定',
                            type: 'error'
                        });
                    }else {
                        var params={typeName:this.typeForm.typeName};
                         getAllTypeList(params).then(data =>{
                            let {data:res={}}=data;
                            if(res.data!=""){
                                 this.$message.error('該類別也存在，請重新輸入！');
                            }else{
                            if (valid) {
                                var params = Object.assign({}, this.typeForm);
                                insertRemark(params).then(data => {
                                    let {data: res = {}} = data;
                                    if (res.errcode == 200) {
                                        this.$message.success('添加成功！');
                                        this.resetForm("homeForm");
                                        this.dialogTypeVisible = false;
                                        this.getRemarkList();
                                    } else {
                                        this.$message.error(res.errmsg);
                                    }
                                }).catch((error) => {
                                    this.$message.error('添加失敗！');
                                })
                            }
                            }
                        });
                    }
                });
            },

            handleSave(){
                this.$refs.homeForm.validate((valid) => {
                    let str = this.isNull();
                    if(str !== ""){
                        this.dialogVisible =true;
                        this.$alert(str, '提示', {
                            confirmButtonText: '確定',
                            type: 'error'
                        });
                    }else {
                        if (valid) {
                            var params = Object.assign({}, this.homeForm);
                            params.typeName='';
                            if (params.id === '') {
                                delete params.id;
                                insertRemark(params).then(data => {
                                    let {data: res = {}} = data;
                                    if (res.errcode == 200) {
                                        this.$message.success('添加成功！');
                                        this.resetForm("homeForm");
                                        this.dialogFormVisible = false;
                                        this.requestRemarkList();
                                    } else {
                                        this.$message.error(res.errmsg);
                                    }
                                }).catch((error) => {
                                    this.$message.error('添加失敗！');
                                })
                            } else {
                                updateRemark(params).then(data => {
                                    this.staffSaveloading = false;
                                    let {data: res = {}} = data;
                                    if (res.errcode == 200) {
                                        this.$message.success('修改成功');
                                        this.requestRemarkList();
                                        this.resetForm("homeForm");
                                        this.dialogFormVisible = false;
                                    } else {
                                        this.$message.error(res.errmsg);
                                    }
                                });
                            }
                        }
                    }
                });
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            },
            isNull(){/*是否为空*/
                if(this.homeForm.typeId ==="" || this.homeForm.typeId === null){
                    return "請選擇類別"
                }
                if(this.homeForm.content ==="" || this.homeForm.content === null){
                    return "請輸入備註內容"
                }
                return "";
            },
            requestDeleteRemark(ids){
                this.$confirm('確定刪除此數據嗎?','提示', {
                    confirmButtonText: '確認',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteRemarkById(ids).then(data=>{
                        let {data:res={}}=data;
                        if(res.errcode==200){
                            this.$message.success('刪除成功!');
                            this.requestRemarkList();
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '刪除失敗'
                    });
                });
            },
            requestRemarkById(id){
                return getRemarkById(id).then(data=>{
                    let {data:res={}}=data;
                    Object.assign(this.homeForm,res.data);
                });
            }
        },
        mounted() {

        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("REMARK_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("REMARK_EDIT");
            },
            canDelete(){
                return this.$store.getters.hasPermission("REMARK_DELETE");
            }
        },
        activated(){
            this.requestRemarkList();//初始化備註管理資料
            this.getRemarkList();//常用列表
        }
    }

</script>

<style lang="scss" scoped>
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .xinz button{background:#4B78FF;border:none;margin-bottom:1rem;margin-left: 10px}
    .xinz button:hover{background:#4B78FF;color:#fff;}
</style>




// WEBPACK FOOTER //
// src/views/Remark.vue